import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { getToken } from '@/utils/auth'
import MainLayout from '@/layouts/MainLayout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    hidden: true,
        meta: {
          title: '欢迎访问会议室预约管理系统！'
        }
  },
  {
    path: '/',
    component: MainLayout,
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('@/views/Home.vue'),
        alias: '/home',
        meta: {
          title: '首页'
        }
      },
      {
        path: 'manage',
        name: 'manage',
        component: () => import('@/views/BookingManage.vue'),
        meta: {
          title: '预约管理'
        }
      },
      {
        path: 'statistics',
        name: 'statistics',
        component: () => import('@/views/Statistics.vue'),
        meta: {
          title: '会议统计'
        }
      },
      {
        path: 'userManage',
        name: 'userManage',
        component: () => import('@/views/UserManage.vue'),
        meta: { roles: ['admin'] ,
        title: '用户管理'},

      },
      {
        path: 'roomManage',
        name: 'roomManage',
        component: () => import('@/views/RoomManage.vue'),
        meta: { roles: ['admin'] ,
        title: '会议室管理'},

      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // next();
  const hasToken = getToken()
  const roles = store.getters.role
  // console.log('to.path:',to.path)
  if (!hasToken) {
    console.log('to.path:',to.path)
    if (to.path !== '/login') {
      return next({ path: '/login' })
    } else {
      return next()
    }
  } else {
    if (to.path === '/login') {
      return next('/home')
    }
    const routeRoles = to.meta.roles
    if (routeRoles && !routeRoles.includes(roles)) {
      return next('/home') // 无权限跳回首页或跳转无权限页面
    }
      return next()
  }
})

export default router
